/* --------------------------------------------------------------------------------------
   app.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class appService {
  /*@ngInject*/
  constructor ($translate, $state, userService, logService, $q) {
    this.init()
    this.$translate = $translate
    this.$state = $state
    this.userService = userService
    this.logService = logService
    this.$q = $q
  }
  init () {
    this.classId = null
    this.testId = null
    this.selectedStudentIds = []
  }
  setSelectedUserFromLoginList(user) {
    this.user = user
  }
  getSelectedUserFromLoginList() {
    return this.user
  }
  setNewUserToken(user, token) {
    this.newUserToken = {user, token}
  }
  getNewUserToken() {
    return this.newUserToken
  }
  handleError(error) {
      if (error.method == "Submit Scan")
        return this.$q.resolve({errorText: "Unable to start scan", unauthorized: false})
      if (error.status == 401)
        return this.$translate('UNAUTHORIZED')
        .then(result => {return {errorText: result, unauthorized: true }})
      if (error.status) {
        return this.logService.log(result)
          .then(refnum => this.$translate(['GENERIC_ERROR', "REFERENCE_NUMBER"], {ref: refnum}))
          .then(result => {return {errorText: result, unauthorized: false }})
      }
      return this.logService.log(error)
        .then(refnum => this.$translate(['GENERIC_ERROR', "REFERENCE_NUMBER"], {ref: refnum}))
        .then(result => {return {errorText: result, unauthorized: false }})
  }
  errorClosed(error) {
    if (error.unauthorized) {
      this.userService.deleteUser(this.user)
      this.user = null
      this.$state.go('users')
    }
    else
      this.$state.go('main')
  }
  setScanStatusTemp(value) {
    this.scanStatus = value
  }
  getScanStatusTemp() {
    if (!this.scanStatus)
        return "No Status yet"
    return "JobState: " + this.scanStatus.jobState + " - JobStateReasons: " + this.scanStatus.jobStateReasons
  }
}



// WEBPACK FOOTER //
// ./src/app/services/app.service.js